import Index from '../views/agencies/Index.vue'

export default [
    {
        path: '/agencies',
        name: 'agencies',
        component: Index,
        meta: { title: 'Agenturen' }
    },
    {
        path: '/agencies/index',
        redirect: '/agencies'
    }

]
